import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { map, Observable, take } from 'rxjs';
import { selectPlanId } from '../store/selectors/authentication.selectors';
import { Store } from '@ngrx/store';
import { PLANES } from '../core/constants/planes';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  stateSnapshot: RouterStateSnapshot):
  Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  const store = inject(Store);
  const router = inject(Router);
  const currentPath = route.routeConfig?.path ?? '';

  const forbiddenByPlan: Record<number, string[]> = {
    [PLANES.B100]: ['tu-cobertura', 'asistencia-al-viajero'],
    [PLANES.PMO]:  ['tu-cobertura', 'asistencia-al-viajero', 'cartilla-medica'],
  };

  return store.select(selectPlanId)
  .pipe(
    take(1),
    map((planId: number) => {
      const forbiddenPaths = forbiddenByPlan[planId] ?? [];

      return forbiddenPaths.includes(currentPath)
        ? router.createUrlTree(['/mi-panel'])
        : true;
    })
  )
}